import HttpReference from '../platform/HttpReference';
import Gatekeeper from './Gatekeeper';

export default class Report extends HttpReference<any, void, Gatekeeper> {
  get() {
    return this.request();
  }
}
